import autobind from 'autobind-decorator';
import { action, observable, runInAction } from 'mobx';
import { asyncAction } from 'mobx-utils';
import { BannerService } from '../services';
import { Url } from '../constants/environment';
import { preloadMedia } from '../../common/cache/mediaCache';
import { Base64 } from 'js-base64';

@autobind
class BannersStore {
  @action setActiveMajorView(id) {
    runInAction(() => {
      this.activeMajorViewId = id;
    });
  }

  @action clearActiveMajorView() {
    runInAction(() => {
      this.activeMajorViewId = null;
      this.isBannerLoaded = false;
    });
  }

  @action setSportType(sportType) {
    runInAction(() => {
      this.sportType = sportType;
    });
  }

  @observable
  activeMajorViewId = null;

  @observable
  isBannerLoaded = false;

  @observable
  code = 200;

  @observable
  message = '';

  @observable
  data = {};

  @observable
  mobileBanner = [];

  @observable
  mobilePopup = [];

  @observable
  sportsMobileBannerLeft = [];

  @observable
  sportsMobileBannerRight = [];

  @observable
  sportType = null;

  @action
  setBannerLoaded = () => {
    runInAction(() => {
      this.isBannerLoaded = true;
    });
  };

  /**
   * Common banner processing logic for both Left and Right side banners
   */
  processBannerSide(sideKey, banners, host) {
    if (!banners) return [];

    let processed = banners;

    // Filter banners by environment
    if (host === `m.${Url.hostNamedWeb}`) {
      processed = processed.filter((item) => item.display === 'Y');
    } else if (host === `m-stage.${Url.hostNamedWeb}`) {
      processed = processed.filter((item) => item.display_stage === 'Y');
    }

    try {
      // Create a hash of banner numbers
      const numbersString = processed
          .filter((item) => item && item.number)
          .map((item) => item.number)
          .join('');
      const hash = Base64.encode(numbersString).toString();

      const flagKey = `${sideKey}Flag`;
      const storedFlag = localStorage.getItem(flagKey) || '';

      if (storedFlag && hash !== storedFlag) {
        localStorage.setItem('clearStorage', '1');
      }
      localStorage.setItem(flagKey, hash);
    } catch (error) {
      console.error(`Failed to process ${sideKey} flags:`, error);
    }

    // Preload media
    preloadMedia(processed?.map((item) => item.imgPath));

    return processed;
  }

  @autobind
  @asyncAction
  *getList() {
    const res = yield BannerService.getList();
    if (res.code === 200) {
      runInAction(() => {
        this.code = res.code;
        this.data = res.data;
        //        this.mobileBanner = res.data.mobileBanner;
        this.popup = res.data.popup;
        let host = window.location.hostname;
        //        console.log(this.sportType)
        if (this.sportType) {
          //          console.log(banners)
          this.mobileBanner = res.data.mobileBanner.filter(
            (item) => item != null && item.sport_type.includes(this.sportType)
          );
          if (host === Url.hostNamedWeb) {
            this.mobileBanner = this.mobileBanner.filter((item) => item.display === 'Y');
          }
          if (host === `stage.${Url.hostNamedWeb}`) {
            this.mobileBanner = this.mobileBanner.filter((item) => item.display_stage === 'Y');
          }
          //          this.mobileBanner = res.data.mobileBanner;
          this.isBannerLoaded = true;
        } else {
          // this.mobileBanner = res.data.mobileBanner;
          this.mobileBanner = [];
          this.isBannerLoaded = false;
        }

        // ✅ Use common processor
        this.sportsMobileBannerLeft = this.processBannerSide(
            'sportsMobileBannerLeft',
            res.data?.sportsMobileBannerLeft || [],
            host
        );

        this.sportsMobileBannerRight = this.processBannerSide(
            'sportsMobileBannerRight',
            res.data?.sportsMobileBannerRight || [],
            host
        );
      });
    } else {
      runInAction(() => {
        this.code = res.code;
        this.message = res.message;
        this.mobileBanner = {};
      });
    }
    return res.code === 200;
  }

  @autobind
  @asyncAction
  *getListPopups() {
    const res = yield BannerService.getList();
    if (res.code === 200) {
      runInAction(() => {
        this.code = res.code;
        this.data = res.data;
        this.mobilePopup = res.data.mobilePopup;
        this.isBannerLoaded = true;
      });
    } else {
      runInAction(() => {
        this.code = res.code;
        this.message = res.message;
      });
    }
    return res.code === 200;
  }
}

//const bannerStore = new BannersStore();
export default BannersStore;
